
import React from 'react';
import { Modal2 } from "../modal";
import { OptionMenu } from "../../../lib/prm/option-menu";
import { Text } from "../../../lib/prm/text";
import {HighlightRects, TextLoading} from "../../funcs/utils";
import { createWlfAdmin } from "./actions";

const render_pair = (component, label, prm) => {
  const container_style = {
    marginTop: "0.5rem",
    width: "100%",
    display: "flex",
  }
  let prm_div;
  if (prm instanceof OptionMenu) {
    prm_div = prm.renderMenu(component, { width: "100%"});
  } else if (prm instanceof Text) {
    prm_div = prm.renderInput(component, { width: "100%" });
  }
  return (
    <div style={container_style}>
      <div style={{flex: "0.5"}}>
        <span>{label}</span>
      </div>
      <div style={{flex: "1"}}>
        { prm_div }
      </div>
    </div>
  )
}

const on_create = (component, prms) => () => {
  const { WLF_MENU, NAME, EMAIL, PASSWORD } = prms;
  const params = [ NAME, EMAIL, PASSWORD ];
  const highlight_rects = [];
  params.forEach(param => {
    param.isFilledElseHighlight(component.state, highlight_rects);
  });

  if (highlight_rects.length > 0) {
    component.setState( { highlight_rects });
    return;
  }

  component.setState( {creating_admin: true });
  createWlfAdmin(
    component.props.token,
    NAME.getValue(component.state),
    WLF_MENU.getValue(component.state).id,
    EMAIL.getValue(component.state),
    PASSWORD.getValue(component.state))
    .then(result => {

      const new_state = {
        creating_admin: false,
        show_dialog: false,
      }

      if (result.error) {
        new_state.error = true;
        new_state.error_msg = result.msg;
      }
      component.setState(new_state);
      if (!result.error) {
        component.onNewAdmin(result.wlf_admin);
      }
    }
  )
}

const NewAdminDialog = props => {
  const header = (
    <div align={"center"}>
      <span>New WLF Admin</span>
    </div>
  );

  const component = props.component;
  const on_cancel = () => component.setState({
    show_dialog: false, highlight_rects: [] });

  const button_list = [
    { id: "cancel", label: "Cancel", cb: on_cancel },
    { id: "create",
      label: (
        <TextLoading
          label={"Create"}
          loading={component.state.creating_admin}/>),
      cb: on_create(component, props.prms) },
  ]
  const on_highlight_click = () => {
    component.setState({ highlight_rects: [] });
  }

  const { WLF_MENU, NAME, EMAIL, PASSWORD } = props.prms;
  return (
    <Modal2
     header={header}
     buttonList={button_list}
     show={true}>
      <div ref={component.dialog_ref} style={{position: "relative"}}>
        <HighlightRects
          rects={component.state.highlight_rects}
          container_ref={component.dialog_ref}
          onClick={on_highlight_click}/>
        { render_pair(component, "WLF:", WLF_MENU) }
        { render_pair(component, "Name:", NAME) }
        { render_pair(component, "Email:", EMAIL) }
        { render_pair(component, "Password:", PASSWORD) }
      </div>
    </Modal2>
  );
};

export { NewAdminDialog };
